export default "__VITE_ASSET__CZxtyOcG__"